import React from 'react';

import cn from 'classnames';
import { useRouteMatch, useHistory } from 'react-router-dom';

import { toastSuccess, toastError } from 'modules/common/toast';
import icon_placeholder from 'assets/images/favicon.ico';

import Brand from '../components/Brand';

export default function ActivateAccount() {
  const router = useHistory();
  const match = useRouteMatch();

  const [isForbidden, setIsForbidden] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);

  const rootApi = process.env.REACT_APP_END_POINT;

  const handleClick = () => {
    (async () => {
      try {
        setIsLoading(true);

        await fetch(`${rootApi}/v1/vendors/registration/resend-verify-email`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email_address: sessionStorage.getItem('is_activate_account'),
          }),
        }).then((res) => {
          const { status } = res;

          if (status === 200) {
            toastSuccess('Email re-sent successfully');
            return;
          }

          toastError('Something went wrong, please try again later');
        });
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    })();
  };

  React.useEffect(() => {
    if (!sessionStorage.getItem('is_activate_account')) {
      router.push('/');
      return null;
    }

    setIsForbidden(false);

    return () => {
      sessionStorage.removeItem('is_activate_account');
    };
  }, [router]);

  if (isForbidden) return null;

  return (
    <div className="h-screen flex fixed top-0 left-0 w-full bg-white">
      <img
        src={icon_placeholder}
        className="absolute top-0 left-0 h-screen opacity-5"
        alt="bg-logo"
        style={{ zIndex: -1 }}
      />

      <div className="m-auto space-y-7 flex flex-col items-center px-5">
        <Brand className="w-auto h-10 mx-auto" url={match?.url} />

        <div className="space-y-3 md:space-y-4 flex flex-col items-center text-center">
          <div className="text-3xl md:text-4xl font-bold text-primary-500">
            Activate your account
          </div>
          <div className="md:text-base2 text-gray-500 space-y-1">
            <div>
              We&apos;ve sent a confirmation link to your email address.
            </div>
            <div className="md:text-base">You can safely close this window</div>
          </div>
        </div>

        <div className="flex justify-center flex-wrap gap-x-3 pt-5 md:pt-7">
          <span>Didn&apos;t receive any email?</span>
          <button
            type="button"
            className={cn(
              'font-bold text-primary-500 focus:outline-none hover:opacity-75',
              {
                'cursor-not-allowed': isLoading,
              }
            )}
            disabled={isLoading}
            onClick={handleClick}
          >
            Resend
          </button>
        </div>
      </div>
    </div>
  );
}
